import React, { Component } from 'react';

class CardHeader extends Component {
    render() {
        return (
            <li className="card-header"><h1 className="title text-center m-0">{this.props.pageTitles}</h1></li>
        );
    }
}

export default CardHeader;